var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line no-restricted-imports
import { useAccountStorage } from '../../../../AppClients';
import { pagerCarrierEntityName } from '../../../../backend/config/classifiers/PagerCarrierClassifier/shared';
import { trimOrganizationPath, } from '../../../../backend/features/accounts/shared';
import { findOrganizationByPath } from '../../../../backend/features/organizations/shared';
import { getMaxOrganizationsPerAccount } from '../../../../backend/utils/getMaxOrganizationsPerAccount';
import { useContactManagementTranslation } from '../../../../ui/hooks/useContactManagementTranslation';
import { isEmailValid } from '@juvare/common-form-ui/WidgetFormEmail';
import { parsePhoneNumber } from '@juvare/common-phone-number';
import { getDataValue, setDataValue } from '@juvare/json-data-util';
import { jurisdictionEntityName, } from '@juvare/platform-sdk-react/backend/features/default-classifiers/shared';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import { formatISO, isValid, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { useSelector } from 'react-redux';
import { getArrayValue, getValue } from '../components/AccountsPanel/components/importUtils';
export const mergeImportWithDestination = (rowObject, data, destination) => {
    const value = getDataValue(rowObject, destination);
    setDataValue(data, destination, value);
    return Object.assign({}, data);
};
export const setWithDestination = (rowObject, destination, value) => {
    setDataValue(rowObject, destination, value);
    return Object.assign({}, rowObject);
};
const findDuplicates = (arr) => arr.filter((item, index) => arr.indexOf(item) != index);
export const handlePhoneNumberArray = ({ phoneNumbers, row, importColumn, t, type }) => {
    const phoneValues = getDataValue(row.object, importColumn.destination);
    const phoneNumberEntities = phoneValues ? [...phoneValues] : [];
    if (phoneNumbers.length) {
        phoneNumbers.forEach((phoneNumber) => {
            const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
            if (!parsedPhoneNumber) {
                row.errors.push(t('import.invalidPhoneNumber', { phoneNumber }));
                return;
            }
            const existingPhoneNumber = phoneNumberEntities.filter((phoneNumberEntity) => phoneNumberEntity.phoneNumber === parsedPhoneNumber);
            if (!existingPhoneNumber.length) {
                phoneNumberEntities.push({
                    phoneNumber: parsedPhoneNumber,
                    type: Object.assign({ fax: false, text: false, voice: false }, { [type]: true }),
                });
            }
            else if (existingPhoneNumber.length === 1 && !existingPhoneNumber[0].type[type]) {
                const phoneNumberIndex = phoneNumberEntities.findIndex((phoneNumberEntity) => phoneNumberEntity.phoneNumber === parsedPhoneNumber);
                phoneNumberEntities[phoneNumberIndex].type[type] = true;
            }
            else {
                row.warnings.push(t('import.duplicateContactPhoneNumber', { phoneNumber }));
            }
        });
    }
    else if (importColumn.required) {
        row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
    }
    return setWithDestination(row.object, importColumn.destination, phoneNumberEntities);
};
/**
 * @deprecated
 * TODO: CNEO-5510 this hook still holds the old frontend import logic. Should be removed since backend import is being used now. Keeping it for
 * backwards compitability due to onExtendedAccountImportColumns callback. Should only use import setting here.
 * */
export const useDefaultAccountImportColumns = () => {
    const { t } = useContactManagementTranslation();
    const settings = useSelector(getSettings);
    const accountStorage = useAccountStorage();
    const jurisdictionStorage = useStorageClient(jurisdictionEntityName);
    const pagerCarrierStorage = useStorageClient(pagerCarrierEntityName);
    return getDefaultAccountImportColumns(t, accountStorage, jurisdictionStorage, pagerCarrierStorage, settings, []);
};
function fetchJurisdictionData(jurisdictionStorage) {
    return __awaiter(this, void 0, void 0, function* () {
        const counties = yield jurisdictionStorage.list({
            filter: [
                { column: 'type', op: '=', value: 'county' },
                { column: 'status', op: '=', value: 'active' },
            ],
        });
        const stateCountyMap = {};
        counties.rows.forEach((county) => {
            const stateCode = county.columns.parentPostalCode;
            if (stateCode) {
                stateCountyMap[stateCode] = [...(stateCountyMap[stateCode] || []), county.columns.name];
            }
        });
        const countyNames = counties.rows.map((row) => row.columns.name);
        const stateCodes = Object.keys(stateCountyMap);
        return { countyNames, stateCodes, stateCountyMap };
    });
}
/**
 * @Deprecated frontend import has been deprecated in favor of backend import. All import code should go to onImport enitity callback.
 * */
export function getDefaultAccountImportColumns(t, accountStorage, jurisdictionStorage, pagerCarrierStorage, settings, organizations) {
    const accountImportColumns = [];
    const defaultAccountImportColumns = settings.accountImport || [];
    const allowedAccountSystemStatuses = ['active', 'inactive', 'closed'];
    for (let i = 0; i < defaultAccountImportColumns.length; i++) {
        const importColumn = defaultAccountImportColumns[i];
        accountImportColumns[i] = {
            headerName: importColumn.headerName,
            exampleValue: importColumn.exampleValue,
            required: importColumn.required,
            validateColumn: () => Promise.reject('validateColumn is not implemented for ' + importColumn.type + ' type'),
        };
        switch (importColumn.type) {
            case 'string':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]);
                        if (rowValue) {
                            if (importColumn.length && rowValue.length > importColumn.length) {
                                row.errors.push(t('import.fieldLengthExceeded', { fieldName: importColumn.headerName }));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, rowValue);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'number':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const parsedNumber = Number(row.data[columnIndex]);
                        if (row.data[columnIndex]) {
                            if (importColumn.length && row.data[columnIndex].length > importColumn.length) {
                                row.errors.push(t('import.fieldLengthExceeded', { fieldName: importColumn.headerName }));
                            }
                            else if (isNaN(parsedNumber)) {
                                row.errors.push(t('import.invalidFieldType', { fieldName: importColumn.headerName }));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, parsedNumber);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'boolean':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        let value = false;
                        const rowValue = getValue(row.data[columnIndex]);
                        if (rowValue) {
                            if (importColumn.length && rowValue.length > importColumn.length) {
                                row.errors.push(t('import.fieldLengthExceeded', { fieldName: importColumn.headerName }));
                            }
                            if (rowValue.toLocaleLowerCase() !== 'true' && rowValue.toLocaleLowerCase() !== 'false') {
                                row.errors.push(t('import.invalidFieldType', { fieldName: importColumn.headerName }));
                            }
                            else {
                                value = rowValue.toLocaleLowerCase() === 'true';
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, value);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'systemRole':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]).toLocaleLowerCase();
                        if (rowValue) {
                            if (!['user', 'client-admin', 'contact'].includes(rowValue)) {
                                row.warnings.push(t('import.wrongSystemRole'));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return Object.assign(Object.assign({}, row.object), { systemRole: rowValue });
                    }), importColumn: (rowObject, data) => (Object.assign(Object.assign({}, data), { systemRole: rowObject.systemRole })) });
                break;
            case 'date':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]);
                        let parsedValue;
                        if (rowValue) {
                            const parsedNumber = Number(rowValue);
                            if (parsedNumber) {
                                parsedValue = parsedNumber;
                            }
                            else {
                                parsedValue = Date.parse(rowValue);
                                if (isValid(parsedValue)) {
                                    parsedValue = formatISO(parsedValue, { representation: 'date' });
                                }
                                else {
                                    row.errors.push(t('import.invalidFieldType', { fieldName: importColumn.headerName }));
                                }
                            }
                            if (importColumn.length && rowValue.length > importColumn.length) {
                                row.errors.push(t('import.fieldLengthExceeded', { fieldName: importColumn.headerName }));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, parsedValue);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'dateTime':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]);
                        let parsedValue;
                        if (rowValue) {
                            const parsedNumber = Number(rowValue);
                            if (parsedNumber) {
                                parsedValue = parsedNumber;
                            }
                            else {
                                parsedValue = parseISO(rowValue);
                                if (isValid(parsedValue)) {
                                    parsedValue = formatInTimeZone(parsedValue, settings.appDateTimeFormat.timeZone, settings.appDateTimeFormat.dateFormat + ' ' + settings.appDateTimeFormat.timeFormat);
                                }
                                else {
                                    row.errors.push(t('import.invalidFieldType', { fieldName: importColumn.headerName }));
                                }
                            }
                            if (importColumn.length && rowValue.length > importColumn.length) {
                                row.errors.push(t('import.fieldLengthExceeded', { fieldName: importColumn.headerName }));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, parsedValue);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'stringArray':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const values = getArrayValue(row.data[columnIndex]);
                        const stringArrayValues = getDataValue(row.object, importColumn.destination);
                        const valueEntities = stringArrayValues ? [...stringArrayValues] : [];
                        if (values.length) {
                            values.forEach((value) => {
                                const valueExists = valueEntities.some((item) => item === value);
                                if (valueExists) {
                                    row.warnings.push(t('import.duplicateValue', { columnHeader: importColumn.headerName, duplicateValue: value }));
                                }
                                else {
                                    valueEntities.push(value);
                                }
                            });
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, valueEntities);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'accountStatus':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row, context) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]).toLocaleLowerCase();
                        if (rowValue) {
                            if (importColumn.length && rowValue.length > importColumn.length) {
                                row.errors.push(t('import.fieldLengthExceeded', { fieldName: importColumn.headerName }));
                            }
                            else if (!allowedAccountSystemStatuses.includes(rowValue) &&
                                !((context === null || context === void 0 ? void 0 : context.importAction) === 'update' && rowValue === 'deleted')) {
                                row.errors.push(t('import.wrongStatus', { availableStatuses: allowedAccountSystemStatuses.join(', ') }));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.statusRequired'));
                        }
                        return Object.assign(Object.assign({}, row.object), { status: rowValue });
                    }), importColumn: (rowObject, data) => (Object.assign(Object.assign({}, data), { systemStatus: rowObject.status })) });
                break;
            case 'accountEmail':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row, context) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]);
                        if (rowValue) {
                            if (importColumn.length && rowValue.length > importColumn.length) {
                                row.errors.push(t('import.fieldLengthExceeded', { fieldName: importColumn.headerName }));
                            }
                            else if (!isEmailValid(rowValue)) {
                                row.errors.push(t('import.invalidContactEmail', { email: rowValue }));
                            }
                            else if (context.uniqueEmails.includes(rowValue)) {
                                row.errors.push(t('import.duplicateEmail'));
                            }
                            else {
                                if (!(context === null || context === void 0 ? void 0 : context.importAction) || context.importAction === 'create') {
                                    const result = yield accountStorage.list({
                                        filter: [
                                            {
                                                column: 'email',
                                                op: '=',
                                                value: rowValue,
                                            },
                                        ],
                                    });
                                    if (result.total > 0) {
                                        row.errors.push(t('import.accountExists'));
                                    }
                                }
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredEmail', { headerName: importColumn.headerName }));
                        }
                        return Object.assign(Object.assign({}, row.object), { email: rowValue });
                    }), importColumn: (rowObject, data) => {
                        return Object.assign(Object.assign({}, data), { email: rowObject.email });
                    } });
                break;
            case 'emailArray':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row, context) => __awaiter(this, void 0, void 0, function* () {
                        const emails = getArrayValue(row.data[columnIndex]);
                        const emailValues = getDataValue(row.object, importColumn.destination);
                        const emailEntities = emailValues ? [...emailValues] : [];
                        if (emails.length) {
                            emails.forEach((email) => {
                                const isDuplicateEmail = context.uniqueEmails.includes(email);
                                const existingEmail = emailEntities.some((emailEntity) => emailEntity.email === email);
                                if (!isEmailValid(email)) {
                                    row.errors.push(t('import.invalidContactEmail', { email }));
                                    return;
                                }
                                if (!existingEmail && !isDuplicateEmail) {
                                    emailEntities.push({
                                        email,
                                    });
                                }
                                else {
                                    row.warnings.push(t('import.duplicateContactEmail', { email: email }));
                                }
                            });
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredEmail', { headerName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, emailEntities);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'phoneNumberTextArray':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const phoneNumbers = getArrayValue(row.data[columnIndex]);
                        return handlePhoneNumberArray({
                            phoneNumbers,
                            row,
                            importColumn,
                            t,
                            type: 'text',
                        });
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'phoneNumberVoiceArray':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const phoneNumbers = getArrayValue(row.data[columnIndex]);
                        return handlePhoneNumberArray({
                            phoneNumbers,
                            row,
                            importColumn,
                            t,
                            type: 'voice',
                        });
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'phoneNumberFaxArray':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const phoneNumbers = getArrayValue(row.data[columnIndex]);
                        return handlePhoneNumberArray({
                            phoneNumbers,
                            row,
                            importColumn,
                            t,
                            type: 'fax',
                        });
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'pagerNumberArray':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { init: () => __awaiter(this, void 0, void 0, function* () {
                        const pagerCarriers = yield pagerCarrierStorage.list({
                            filter: [{ column: 'status', op: '=', value: 'active' }],
                        });
                        return { pagerCarriers };
                    }), validateColumn: (columnIndex, row, context) => __awaiter(this, void 0, void 0, function* () {
                        const pagers = getArrayValue(row.data[columnIndex]);
                        const pagerValues = getDataValue(row.object, importColumn.destination);
                        const pagerNumberEntities = pagerValues ? [...pagerValues] : [];
                        if (pagers.length === 0 && importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        if (pagers.length) {
                            const duplicates = findDuplicates(pagers);
                            if (duplicates.length) {
                                duplicates.forEach((duplicate) => {
                                    row.errors.push(t('import.duplicatePagerNumbers', { listValue: duplicate }));
                                });
                            }
                            pagers.forEach((pager) => {
                                const pagerIsInvalid = pager.indexOf('@') === -1;
                                const carrierDomainName = pager.substring(pager.indexOf('@') + 1);
                                if (pagerIsInvalid) {
                                    row.errors.push(t('import.invalidPager', { pager: pager }));
                                    return;
                                }
                                else if (carrierDomainName.length === 0) {
                                    row.errors.push(t('import.invalidDomainName'));
                                    return;
                                }
                                const phoneNumber = pager.substring(0, pager.indexOf('@'));
                                if (phoneNumber.length !== 10) {
                                    row.errors.push(t('import.invalidPagerNumberLength', { pagerNumber: phoneNumber }));
                                    return;
                                }
                                if (!phoneNumber.match(/^\d+$/)) {
                                    row.errors.push(t('import.invalidPagerNumber', { pagerNumber: phoneNumber }));
                                    return;
                                }
                                const [pagerCarrier] = context['pagerCarriers'].rows.filter(
                                //eslint-disable-next-line @typescript-eslint/no-explicit-any
                                (item) => item.columns.domainName === carrierDomainName);
                                if (!pagerCarrier) {
                                    row.errors.push(t('import.carrierDoesNotExist', { carrier: carrierDomainName }));
                                }
                                else {
                                    pagerNumberEntities.push({ number: phoneNumber, carrier: pagerCarrier.id });
                                }
                            });
                        }
                        return setWithDestination(row.object, importColumn.destination, pagerNumberEntities);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'organizationArray':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { validateColumn: (columnIndex, row) => __awaiter(this, void 0, void 0, function* () {
                        const organizationIds = [];
                        const values = getArrayValue(row.data[columnIndex]);
                        if (values.length) {
                            const duplicates = findDuplicates(values);
                            if (duplicates.length) {
                                new Set(duplicates).forEach((duplicate) => {
                                    row.warnings.push(t('import.duplicateOrganizationListValue', { listValue: duplicate }));
                                });
                            }
                            const uniqueValues = Array.from(new Set(values));
                            const maxOrganizationsPerAccount = getMaxOrganizationsPerAccount(settings);
                            if (maxOrganizationsPerAccount && uniqueValues.length > maxOrganizationsPerAccount) {
                                row.errors.push(t('import.organizationsLimit', { maxOrganizationsPerAccount: maxOrganizationsPerAccount }));
                            }
                            uniqueValues.forEach((value) => {
                                const path = trimOrganizationPath(value);
                                const org = findOrganizationByPath(organizations, path);
                                if (!org) {
                                    row.warnings.push(t('import.invalidOrganizationListValue', { listValue: path }));
                                }
                                else {
                                    organizationIds.push(org.id);
                                }
                            });
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.organizationsRequired'));
                        }
                        return Object.assign(Object.assign({}, row.object), { organizationIds: organizationIds });
                    }), importColumn: (rowObject, data) => {
                        var _a;
                        const [defaultRole] = (_a = Object.entries(settings.orgRoleMap).find(([, role]) => !!role.default)) !== null && _a !== void 0 ? _a : [];
                        const organizationIds = rowObject.organizationIds;
                        if (organizationIds.length) {
                            const orgRole = {};
                            const orgStatus = {};
                            organizationIds.forEach((value) => {
                                orgRole[value] = defaultRole || 'user';
                                orgStatus[value] = 'accepted';
                            });
                            return Object.assign(Object.assign({}, data), { orgRole: Object.assign(Object.assign({}, data.orgRole), orgRole), orgStatus: Object.assign(Object.assign({}, data.orgStatus), orgStatus) });
                        }
                        return data;
                    } });
                break;
            case 'stateCode':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { init: () => __awaiter(this, void 0, void 0, function* () {
                        return fetchJurisdictionData(jurisdictionStorage);
                    }), validateColumn: (columnIndex, row, context) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]).toLocaleUpperCase();
                        if (rowValue) {
                            const [stateCode] = context['stateCodes'].filter((item) => item.toLocaleUpperCase() === rowValue);
                            if (!stateCode) {
                                row.errors.push(t('import.invalidStateCode', { value: rowValue }));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, rowValue);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
            case 'countyName':
                accountImportColumns[i] = Object.assign(Object.assign({}, accountImportColumns[i]), { init: () => __awaiter(this, void 0, void 0, function* () {
                        return fetchJurisdictionData(jurisdictionStorage);
                    }), validateColumn: (columnIndex, row, context) => __awaiter(this, void 0, void 0, function* () {
                        const rowValue = getValue(row.data[columnIndex]);
                        if (rowValue) {
                            const [countyName] = context['countyNames'].filter((item) => item === rowValue);
                            if (!countyName) {
                                row.errors.push(t('import.invalidCountyName', { value: rowValue }));
                            }
                        }
                        else if (importColumn.required) {
                            row.errors.push(t('import.requiredField', { fieldName: importColumn.headerName }));
                        }
                        return setWithDestination(row.object, importColumn.destination, rowValue);
                    }), importColumn: (rowObject, data) => mergeImportWithDestination(rowObject, data, importColumn.destination) });
                break;
        }
    }
    return accountImportColumns;
}
